// Material UI
import {
  Grid,
  Chip,
  Icon,
  FormControlLabel,
  // FormGroup,
  // Switch,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  FormHelperText,
} from '@mui/material';

// Componentes
import BasicSelect from '@components/Selects/BasicSelect';

// Utils
import { getFormikUtil } from '@utils/Utilities';

const VolunteerForm = (props) => {
  const {
    catalogs,
    formik,
    isLoading,
  } = props;

  const getFormik = (value) => getFormikUtil(formik, 'volunteer', value);
  console.log('volunteer form values', getFormik('EsVoluntario')?.value);

  const handleEsVoluntarioChange = (e) => {
    formik.setFieldValue('volunteer.EsVoluntario', e.target.value);
    formik.setFieldValue('volunteer.idDeseaParticipar', null);
    formik.setFieldValue('volunteer.idVoluntario', null);
  };

  const handleDeseaParticiparChange = (e) => {
    formik.setFieldValue('volunteer.idDeseaParticipar', e.target.value);
    formik.setFieldValue('volunteer.idVoluntario', null);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Chip icon={<Icon>accessibility</Icon>} label="¿Participas en alguna actividad en Accion Nacional?" />
      </Grid>

      <Grid item xs={12}>
        <FormControl error={getFormik('EsVoluntario')?.error}>
          <RadioGroup
            row
            name="volunteer.EsVoluntario"
            value={getFormik('EsVoluntario')?.value}
            onChange={handleEsVoluntarioChange}
          >
            <FormControlLabel value={1} control={<Radio />} label="Sí" />
            <FormControlLabel value={0} control={<Radio />} label="No" />
          </RadioGroup>
          {getFormik('EsVoluntario')?.error && (
            <FormHelperText>{getFormik('EsVoluntario')?.helperText}</FormHelperText>
          )}
        </FormControl>
      </Grid>

      {getFormik('EsVoluntario')?.value !== null && Number(getFormik('EsVoluntario')?.value) === 0 && (
        <>
          <Grid item xs={12} sm="auto">
            <FormControl error={getFormik('DeseaParticipar')?.error}>
              <FormLabel>¿Deseas participar en alguna actividad?</FormLabel>
              <RadioGroup
                row
                name="volunteer.idDeseaParticipar"
                value={getFormik('idDeseaParticipar')?.value}
                onChange={handleDeseaParticiparChange}
              >
                <FormControlLabel value={1} control={<Radio />} label="Sí" />
                <FormControlLabel value={0} control={<Radio />} label="No" />
              </RadioGroup>
              {getFormik('idDeseaParticipar')?.error && (
                <FormHelperText>{getFormik('idDeseaParticipar')?.helperText}</FormHelperText>
              )}
            </FormControl>
          </Grid>

          {Number(getFormik('idDeseaParticipar')?.value) === 1 && (
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <BasicSelect
                size="small"
                name="volunteer.idVoluntario"
                label="¿En qué actividad desea participar?"
                options={catalogs.voluntarios}
                value={getFormik('idVoluntario').value}
                onChange={formik.handleChange}
                sx={{ width: '100%' }}
                isLoading={isLoading}
                error={getFormik('idVoluntario').error}
                errorMessage={getFormik('idVoluntario').helperText}
              />
            </Grid>
          )}
        </>
      )}

      {Number(getFormik('EsVoluntario')?.value) === 1 && (
        <>
          <Grid item xs={12}>
            <FormLabel>¿En qué actividad participas?</FormLabel>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <BasicSelect
              size="small"
              error={getFormik('idVoluntario').error}
              errorMessage={getFormik('idVoluntario').helperText}
              name="volunteer.idVoluntario"
              label="Propuesta *"
              options={catalogs.voluntarios}
              value={getFormik('idVoluntario').value}
              onChange={formik.handleChange}
              sx={{ width: '100%' }}
              isLoading={isLoading}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default VolunteerForm;
